module.exports = __webpack_public_path__ + "static/media/2.64a4818d.png";